import clsx from 'clsx';
import { KeyboardEvent, useCallback } from 'react';
import { ChevronLeft, ChevronRight } from 'react-feather';

import { KeyCode } from '@vestico/utils';

import { Button } from '@vestico/shared';

import style from './RowLayoutArrow.module.css';

const BUTTON_COLOR = '#5a5a5a';
const BUTTON_SIZE = 28;
const BUTTON_STROKE_WIDTH = 3;

export interface RowLayoutArrowProps {
  type: 'PREV' | 'NEXT';
  isRTL: boolean;
  onClick: () => void;
  hidden?: boolean;
}

export const RowLayoutArrow = ({ type, isRTL, onClick, hidden }: RowLayoutArrowProps) => {
  const previous = type === 'PREV';
  const leftArrow = (previous && !isRTL) || (!previous && isRTL);

  const handleKeyUp = useCallback(
    (e: KeyboardEvent<HTMLDivElement>) => {
      e.preventDefault();
      e.stopPropagation();

      if (e.code === KeyCode.enter) {
        onClick();
      }
    },
    [onClick]
  );

  return (
    <div
      className={clsx(style.root, { [style.prev]: leftArrow, [style.next]: !leftArrow, [style.hidden]: hidden })}
      onClick={onClick}
      onKeyUp={handleKeyUp}
      tabIndex={0}
      role="button"
    >
      <Button
        plain
        onClick={onClick}
        ariaLabel={type === 'PREV' ? 'previous' : 'next'}
        content={
          leftArrow ? (
            <ChevronLeft color={BUTTON_COLOR} size={BUTTON_SIZE} strokeWidth={BUTTON_STROKE_WIDTH} style={{ fill: 'none' }} className={style.arrow} />
          ) : (
            <ChevronRight
              color={BUTTON_COLOR}
              size={BUTTON_SIZE}
              strokeWidth={BUTTON_STROKE_WIDTH}
              style={{ fill: 'none' }}
              className={style.arrow}
            />
          )
        }
      />
    </div>
  );
};
